"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.AnalyticsContext = void 0;

var _react = _interopRequireDefault(require("react"));

var noAnalytics = function noAnalytics() {
  console.error('[AnalyticsContext] Analytics not initilizized');
};

var AnalyticsContext = /*#__PURE__*/_react.default.createContext({
  enabled: false,
  set: noAnalytics,
  event: noAnalytics,
  pageview: noAnalytics,
  modalview: noAnalytics
});

exports.AnalyticsContext = AnalyticsContext;
var _default = AnalyticsContext;
exports.default = _default;